import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = [
    "customerSelect",
    "currencyInput",
    "discountCheckbox",
    "documentItem",
    "exchangeRate",
    "exchangeRateContainer",
    "exchangeRateCurrencyLabel",
    "exchangeRateInverted",
    "totalAmountWithVat",
    "totalAmountWithVatDisplay",
    "totalAmountWithVatWithoutExchange",
    "totalAmount",
    "totalAmountDisplay",
    "totalVat",
    "contactVisibleCheckbox",
    "showSepaQrCheckbox",
    "sepaQrSection",
    "companyContactInfo",
    "emptyCustomer",
    "customerInfo",
    "saveButton",
    "bankAccountIban",
    "bankAccountSwift",
  ];
  static values = {
    currency: String,
    locale: String,
    workspaceCurrency: String,
  };

  connect() {
    console.log("this.localeValue", {
      locale: this.localeValue,
      currency: this.currencyValue,
      this: this,
    });

    this.checkContactVisible();
    this.recalculateTotalAmount();
    this.checkCustomerInfo();
    this.initializeSortable();

    // Hide SEPA QR section if currency is not EUR
    if (this.currencyValue !== "EUR") {
      this.showSepaQrCheckboxTarget.checked = false;
      this.showSepaQrCheckboxTarget.disabled = true;
      this.sepaQrSectionTarget.classList.add("hidden");
    }
  }

  checkBankAccountSwift(event) {
    console.log("🅱️ checkBankAccountSwift", event);
  }

  checkCustomerInfo() {
    // const customerIdFormValue
  }

  selectInputContent(event) {
    event.target.select();
  }

  toggleDiscount(event) {
    // TODO: Implement this method
  }

  checkContactVisible() {
    const checked = this.contactVisibleCheckboxTarget.checked;
    this.companyContactInfoTarget.classList.toggle("hidden", !checked);
  }

  toggleContactVisible(event) {
    const checked = event.target.checked;
    this.companyContactInfoTarget.classList.toggle("hidden", !checked);
  }

  achjaj(event) {
    console.log("som tu");
    const checked = event.target.checked;
    console.log("toggleDocumentItemsTotalFields checked", { event, checked });
    this.totalAmountWithVatTargets.forEach((item) =>
      item.classList.toggle("hidden", !checked)
    );
    this.totalAmountTargets.forEach((item) =>
      item.classList.toggle("hidden", !checked)
    );
    // this.totalAmountWithVatTargets.forEach(item => item.classList.toggle("hidden", !checked);)
    // this.totalAmountDisplayTarget.classList.forEach(item => item.toggle("hidden", !checked));
  }

  // Document items
  recalculateTotalAmount() {
    let totalAmount = 0;
    let totalAmountWithVat = 0;

    let exchangeRate = 1;

    if (this.hasExchangeRateTarget) {
      exchangeRate = this.exchangeRateTarget.value || 1;
    }

    this.documentItemTargets.forEach((item) => {
      const quantity =
        parseFloat(
          item.querySelector(
            "[data-documents--form-target='documentItem.quantity']"
          ).value
        ) || 0;
      const unitPrice =
        parseFloat(
          item.querySelector(
            "[data-documents--form-target='documentItem.unitPrice']"
          ).value
        ) || 0;
      const vatRate =
        parseFloat(
          item.querySelector(
            "[data-documents--form-target='documentItem.vatRate']"
          )?.value || 0
        ) || 0;

      let vatRateInPercent = vatRate <= 0 ? 0 : vatRate;

      if (vatRate >= 0 && vatRate < 100) {
        vatRateInPercent = vatRate / 100 + 1;
      }

      const itemTotalAmount = quantity * unitPrice;
      const itemTotalAmountWithVat = itemTotalAmount * vatRateInPercent;

      item.querySelector(
        "[data-documents--form-target='documentItem.totalAmount']"
      ).value = itemTotalAmount.toFixed(2);
      item.querySelector(
        "[data-documents--form-target='documentItem.totalAmountWithVat']"
      ).value = itemTotalAmountWithVat.toFixed(2);

      totalAmount += itemTotalAmount;
      totalAmountWithVat += itemTotalAmountWithVat;
    });

    const currencyFormatter = new Intl.NumberFormat(this.localeValue ?? "sk", {
      style: "currency",
      currency: this.currencyValue ?? "EUR",
    });
    // Adjusts hidden inputs
    // Exchange rate in form is display format: "1 workspace = X document"
    // To convert document amount to workspace: amount / display_rate
    this.totalAmountTargets.forEach((target) => {
      target.value = (totalAmount / exchangeRate).toFixed(2);
    });

    this.totalAmountWithVatTargets.forEach((target) => {
      target.value = (totalAmountWithVat / exchangeRate).toFixed(2);
    });

    // Adjusts display texts
    this.totalVatTargets.forEach((target) => {
      // Inner HTML
      target.innerHTML = currencyFormatter.format(
        (totalAmountWithVat - totalAmount).toFixed(2)
      );
    });
    this.totalAmountDisplayTargets.forEach((target) => {
      // Inner HTML
      target.innerHTML = currencyFormatter.format(totalAmount.toFixed(2));
    });
    this.totalAmountWithVatDisplayTargets.forEach((target) => {
      // Inner HTML
      target.innerHTML = currencyFormatter.format(
        totalAmountWithVat.toFixed(2)
      );
    });
  }

  removeItem(event) {
    event.preventDefault();
    const row = event.target.closest(".document_item");
    const idField = row.querySelector("input[name*='[id]']");
    const destroyField = row.querySelector("input[name*='[_destroy]']");

    if (idField && idField.value) {
      // Existing item - mark for destruction and hide
      destroyField.value = "1";
      row.classList.add("hidden");
    } else {
      // New item - just remove from DOM
      row.remove();
    }
    this.recalculateTotalAmount();
  }

  initializeSortable() {
    const el = document.getElementById("document_items_body");
    if (el) {
      Sortable.create(el, {
        handle: ".sortable-handle",
        animation: 150,
        onEnd: (evt) => {
          // this.recalculateTotalAmount();
          console.log("reorder", evt);
          this.documentItemTargets.forEach((item, itemIndex) => {
            console.log("#", itemIndex, " -- item", item);
            item.querySelector(
              "[data-documents--form-target='documentItem.position']"
            ).value = itemIndex + 1;
          });
        },
      });
    }
  }

  async onCurrencyChange(event) {
    const newCurrency = event.detail?.value || event.target.value;
    this.currencyValue = newCurrency.toUpperCase();

    // Update the currency label in the exchange rate display
    if (this.hasExchangeRateCurrencyLabelTarget) {
      this.exchangeRateCurrencyLabelTarget.textContent =
        newCurrency.toUpperCase();
    }

    // Update SEPA QR visibility based on currency
    if (this.currencyValue !== "EUR") {
      this.showSepaQrCheckboxTarget.checked = false;
      this.showSepaQrCheckboxTarget.disabled = true;
      this.sepaQrSectionTarget.classList.add("hidden");
    } else {
      this.showSepaQrCheckboxTarget.disabled = false;
    }

    // If currency is same as workspace, hide exchange rate and reset to 1
    if (
      newCurrency.toLowerCase() === this.workspaceCurrencyValue?.toLowerCase()
    ) {
      if (this.hasExchangeRateContainerTarget) {
        this.exchangeRateContainerTarget.classList.add("hidden");
      }
      if (this.hasExchangeRateTarget) {
        this.exchangeRateTarget.value = 1;
      }
      this.recalculateTotalAmount();
      return;
    }

    // Fetch exchange rate from API
    try {
      const response = await fetch(`/exchange_rates/${newCurrency}`);
      const data = await response.json();

      if (this.hasExchangeRateTarget && data.rate) {
        this.exchangeRateTarget.value = data.rate;
        this.updateInvertedRateDisplay(data.rate, newCurrency.toUpperCase());
      }
      if (this.hasExchangeRateContainerTarget) {
        this.exchangeRateContainerTarget.classList.remove("hidden");
      }
      this.recalculateTotalAmount();
    } catch (error) {
      console.error("Failed to fetch exchange rate:", error);
    }
  }

  updateExchangeRate() {
    const displayRate = parseFloat(this.exchangeRateTarget.value) || 1;
    const documentCurrency =
      this.exchangeRateInvertedTarget?.dataset.documentCurrency ||
      this.currencyValue;

    this.updateInvertedRateDisplay(displayRate, documentCurrency);
    this.recalculateTotalAmount();
  }

  updateInvertedRateDisplay(displayRate, documentCurrency) {
    if (!this.hasExchangeRateInvertedTarget) return;

    const workspaceCurrency =
      this.exchangeRateInvertedTarget.dataset.workspaceCurrency ||
      this.workspaceCurrencyValue?.toUpperCase();

    // Invert the display rate and round to 5 significant figures
    const invertedRate =
      displayRate > 0 ? this.roundToSignificant(1 / displayRate, 5) : 1;

    this.exchangeRateInvertedTarget.textContent = `1 ${documentCurrency} = ${invertedRate} ${workspaceCurrency}`;
    this.exchangeRateInvertedTarget.dataset.documentCurrency = documentCurrency;
  }

  roundToSignificant(number, sigFigs) {
    if (number === 0) return 0;
    const d = sigFigs - Math.floor(Math.log10(Math.abs(number))) - 1;
    return Math.round(number * Math.pow(10, d)) / Math.pow(10, d);
  }
}
